export const orderStatus = {
  Preparation: "Preparation",
  Shipped: "Shipped",
  Delivered: "Delivered",
  Paid: "Paid",
  Canceled: "Canceled",
  Created: "Created",
} as const;
